module.exports = __webpack_public_path__ + "img/logo.b8bf0c6f.svg";